import styled from "styled-components";

const ZainiqSignupPageDisplay = styled.div`
  --zain-bg: #031f1f;
  --zain-bg-deep: #021818;
  --zain-cyan: #44d7c3;
  --zain-cyan-soft: rgba(68, 215, 195, 0.85);
  --zain-btn-dark: #031f1f;

  min-height: 100vh;
  background: var(--zain-bg);
  color: #fff;
  font-family: inherit;

  .zainiq-page {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
  }

  .zainiq-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px 8px;
    position: relative;
    z-index: 2;
  }

  .zainiq-lang-btn {
    min-width: 88px;
    padding: 8px 20px;
    border-radius: 999px;
    border: 1px solid var(--zain-cyan);
    background: transparent;
    color: #fff;
    font-size: 0.95rem;
    cursor: pointer;
  }

  .zainiq-lang-btn.active {
    background: rgba(68, 215, 195, 0.12);
  }

  .zainiq-logo-link {
    display: block;
    line-height: 0;
  }

  .zainiq-logo {
    width: 140px;
    max-width: 42vw;
    height: 36px;
    background: var(--navbarLogo, var(--loginLogo)) center right no-repeat;
    background-size: contain;
    margin-left: auto;
  }

  .zainiq-main {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 8px 24px 180px;
    position: relative;
    z-index: 2;
  }

  .zainiq-dots {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin: 12px 0 20px;
  }

  .zainiq-dots span {
    display: block;
    border-radius: 50%;
    background: var(--zain-cyan);
    opacity: 0.9;
  }

  .zainiq-dots span:nth-child(1) {
    width: 10px;
    height: 10px;
  }
  .zainiq-dots span:nth-child(2) {
    width: 14px;
    height: 14px;
  }
  .zainiq-dots span:nth-child(3) {
    width: 18px;
    height: 18px;
  }

  .zainiq-hero-title {
    margin: 0 0 16px;
    font-size: clamp(1.75rem, 7vw, 2.35rem);
    font-weight: 800;
    line-height: 1.25;
    color: #fff;
  }

  .zainiq-hero-sub {
    margin: 0;
    max-width: 320px;
    font-size: clamp(0.95rem, 3.8vw, 1.05rem);
    line-height: 1.55;
    color: var(--zain-cyan-soft);
  }

  .zainiq-hero-sub + .zainiq-hero-sub {
    margin-top: 6px;
  }

  .zainiq-phone-wrap {
    width: 100%;
    max-width: 320px;
    margin: 28px auto 8px;
  }

  .zainiq-phone-input {
    width: 100%;
    box-sizing: border-box;
    padding: 14px 16px;
    border-radius: 12px;
    border: 1px solid rgba(68, 215, 195, 0.45);
    background: rgba(0, 0, 0, 0.25);
    color: #fff;
    font-size: 1rem;
    text-align: center;
    direction: ltr;
  }

  .zainiq-phone-input::placeholder {
    color: rgba(255, 255, 255, 0.45);
  }

  .zainiq-phone-input:focus {
    outline: none;
    border-color: var(--zain-cyan);
    box-shadow: 0 0 0 2px rgba(68, 215, 195, 0.2);
  }

  .zainiq-chevrons {
    margin: 20px 0 16px;
    color: var(--zain-cyan);
    font-size: 1.1rem;
    letter-spacing: 4px;
    opacity: 0.95;
  }

  .zainiq-cta-btn {
    display: block;
    width: min(100%, 320px);
    margin: 0 auto;
    padding: 16px 32px;
    border: none;
    border-radius: 999px;
    font-size: 1.35rem;
    font-weight: 800;
    color: var(--zain-btn-dark);
    cursor: pointer;
    background: linear-gradient(
      180deg,
      #5de8d4 0%,
      #44d7c3 45%,
      #2ec4b0 100%
    );
    box-shadow:
      0 0 0 3px rgba(68, 215, 195, 0.35),
      0 8px 28px rgba(68, 215, 195, 0.35);
    transition: transform 0.15s ease, box-shadow 0.15s ease;
  }

  .zainiq-cta-btn:hover:not(:disabled) {
    transform: translateY(-1px);
  }

  .zainiq-cta-btn:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }

  .zainiq-ready-text {
    margin: 14px 0 0;
    font-size: 0.95rem;
    color: var(--zain-cyan-soft);
  }

  .zainiq-verify-section {
    width: 100%;
    max-width: 320px;
    margin: 24px auto 0;
    text-align: center;
  }

  .zainiq-verify-section p {
    color: var(--zain-cyan-soft);
    margin-bottom: 16px;
  }

  .zainiq-verify-section .input {
    width: 100%;
    box-sizing: border-box;
    padding: 14px 16px;
    border-radius: 12px;
    border: 1px solid rgba(68, 215, 195, 0.45);
    background: rgba(0, 0, 0, 0.25);
    color: #fff;
    text-align: center;
    margin-bottom: 16px;
  }

  .zainiq-wave-footer {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    padding: 72px 20px 28px;
    background: linear-gradient(
      180deg,
      transparent 0%,
      rgba(2, 40, 40, 0.85) 35%,
      #023030 100%
    );
    clip-path: ellipse(120% 100% at 50% 100%);
  }

  .zainiq-wave-footer::before {
    content: "";
    position: absolute;
    left: -10%;
    right: -10%;
    top: 0;
    height: 48px;
    background: radial-gradient(
      ellipse 80% 100% at 50% 0%,
      rgba(68, 215, 195, 0.08) 0%,
      transparent 70%
    );
    pointer-events: none;
  }

  .zainiq-terms {
    position: relative;
    z-index: 1;
    max-width: 360px;
    margin: 0 auto;
    text-align: center;
    font-size: 0.72rem;
    line-height: 1.45;
    color: var(--zain-cyan-soft);
  }

  .zainiq-terms h3 {
    display: none;
  }

  .zainiq-terms p {
    margin: 0;
    font-size: inherit;
    color: inherit;
  }

  .load {
    background: rgba(3, 31, 31, 0.75);
  }

  @media (max-width: 380px) {
    .zainiq-main {
      padding-left: 16px;
      padding-right: 16px;
    }
  }
`;

export default ZainiqSignupPageDisplay;
